import React, {useState, useEffect} from 'react';
import * as yup from 'yup';
import {t} from 'react-switch-lang';
import {useUserContext} from '../../contexts/UserContext';
import {FormProvider, useForm} from 'react-hook-form';
import InputYear from '../../components/FormFields/inputDate/InputYear';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import {format} from 'date-fns';
import {yupResolver} from '@hookform/resolvers';

const InternalAuditRecommendationsReport = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const schema = yup.object().shape({
    year: yup.object().nullable().required(t('message.fieldRequired'))
  });
  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {watch} = methods;

  const validFrom = watch('year');

  useEffect(() => {
    setIsSubmitted(false);
  }, []);
  return (
    <div className="reports-page content">
      <FormProvider {...methods}>
        <div className="report-form-container" key={window.location.pathname}>
          <div className="row  ml-0 mr-0">
            <div className="form-group pr-5">
              <label className="label" htmlFor="year">
                {t('reports.year')}
              </label>
              <InputYear
                name="year"
                placeholderText={t('reports.yearPlaceholder')}
              />
              {
                validFrom === null && isSubmitted === true
                  ? <span className="error-message position-absolute">{t('message.fieldRequired')}</span>
                  : ''
              }
            </div>
            <DownloadBtn
              api={'reports/revision-recommendation-registry'}
              paramsLength={1}
              setIsSubmitted={(e) => setIsSubmitted(e)}
              apiParameters={{
                year:
                  validFrom !== null && validFrom !== undefined
                    ? `year=${encodeURIComponent(
                      format(validFrom, 'yyyy')
                    )}`
                    : ''
              }}
            />
          </div>
        </div>
      </FormProvider>
    </div>
  );
};

export default InternalAuditRecommendationsReport;